import { branchesIds } from "../pages/Admin/shared/static-options";

export function isAgroDivision(divisions) {
  return divisions.includes(String(branchesIds.LUFT_AGRO));
}

export function isHealthCareDivision(divisions) {
  return divisions.includes(String(branchesIds.LUFT_HC));
}